"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { FarminstaIntroLayout } from "../home/landing-page";
import { Globe, Mail, Phone } from "lucide-react";
import { useDemoModal } from "@/hooks/useDemoModal";
import { Button } from "@/components/ui/button";

export const FarminstaPricing = () => {
  const router = useRouter();
   const { openModal, DemoModal } = useDemoModal();
     
    const handleDemo = () => {
          openModal();
    }

  return (
    <div className="min-h-screen mt-10">
      {/* Hero Section */}
      <section className="relative py-10 px-4 sm:px-6 lg:px-2 text-center overflow-hidden">
        <div className="absolute top-[-200px] left-1/2 transform -translate-x-1/2 w-[800px] h-[400px] bg-gradient-radial from-[#FBE8E0] to-transparent opacity-60 pointer-events-none z-0"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-primary rounded-full mb-7">
            {/* <span className="w-2 h-2 bg-primary rounded-full"></span> */}
            <span className="text-md font-medium text-primary uppercase tracking-wider">
              Simple Pricing · One Platform · One Programme
            </span>
          </div>
          
          <h1 className="text-md md:text-5xl font-semibold leading-tight tracking-tight text-[#1A1612] mb-6">
            Two ways to run your season.
          </h1>
          
          <p className="text-xl leading-relaxed text-[#3D362F] max-w-3xl mx-auto">
            A SaaS platform your team runs, or a 90-day managed programme we run with you. Most brands use both. Pricing scales with your field force, your geography, and your scope — talk to us for a firm quote within one working day.
          </p>

          {/* Toggle */}
          {/* <div className="flex justify-center mb-4">
            <div className="inline-flex bg-white border border-[#E3DAD0] rounded-full p-1 gap-1">
              <button
                onClick={() => setIsAnnual(false)}
                className={`px-6 py-2.5 rounded-full font-sans text-sm font-semibold tracking-tight transition-all duration-250 ${
                  !isAnnual
                    ? "bg-[#1A1612] text-white"
                    : "bg-transparent text-[#7A6E62]"
                }`}
              >
                Per Season
              </button>
              <button
                onClick={() => setIsAnnual(true)}
                className={`px-6 py-2.5 rounded-full font-sans text-sm font-semibold tracking-tight transition-all duration-250 ${
                  isAnnual
                    ? "bg-[#1A1612] text-white"
                    : "bg-transparent text-[#7A6E62]"
                }`}
              >
                Annual (Save 15%)
              </button>
            </div>
          </div> */}
        </div>
      </section>

      {/* Pricing Cards */}
      <section className="px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 mb-6">
            
            {/* Field Force Monitor Card */}
            <div className="bg-white border border-[#E3DAD0] rounded-3xl p-4 relative overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl flex flex-col">
              <div className="absolute top-0 left-0 right-0 h-1.5 bg-[#22A850]"></div>
              
              <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#D8F0DF] rounded-full self-start mb-4">
                <span className="w-1.5 h-1.5 bg-[#22A850] rounded-full"></span>
                <span className="text-[10.5px] font-medium text-[#176B33] uppercase tracking-widest">
                  The Platform
                </span>
              </div>

              <h2 className=" text-3xl font-semibold  tracking-tight text-[#1A1612] mb-2">
                Field Force Monitor
              </h2>
              <p className="text-lg text-[#7A6E62] mb-4">
                Your agri operating system.
              </p>

              <div className="py-2 border-t border-b border-[#E3DAD0] mb-8">
                <p className=" text-[11px] uppercase tracking-widest text-[#7A6E62] mb-2.5">
                  Starting at
                </p>
                <div className="flex items-baseline gap-2 flex-wrap">
                  <span className="text-4xl font-medium text-[#1A1612]">₹</span>
                  <span className="text-4xl font-semibold leading-none tracking-tight text-[#1A1612]">
                    500
                  </span>
                  <span className="text-base font-medium text-[#7A6E62] ml-1">
                    / user / month
                  </span>
                </div>
              </div>

              {/* <div className="mb-4">
                <p className="text-base leading-relaxed text-[#3D362F]">
                  <strong className="text-[11px] font-semibold uppercase tracking-widest text-[#1A1612] block mb-2">
                    Ideal for
                  </strong>
                  Agri-input brands running their own field force across Kharif, Rabi, and Zaid — and the sales leaders who want every FO, every farmer, and every demo on one operating system.
                </p>
              </div> */}

              <p className="text-[15px] font-semibold uppercase tracking-widest text-[#1A1612] mb-4">
                Eight modules · One platform
              </p>

              <ul className="">
                {[
                  { label: "FO HRMS", desc: "attendance, daily plans, payroll" },
                  { label: "Farmer CRM", desc: "with proprietary database" },
                  { label: "Demo Lifecycle Tracking", desc: "booked, conducted, converted" },
                  { label: "Channel & Retailer Liquidation Tracking", desc: "" },
                  { label: "Digital Marketing Hub", desc: "campaigns, rewards, CRM" },
                  { label: "Intelligence Cockpit", desc: "with Geo-Spatial Hex Grid" },
                  // { label: "21-day implementation", desc: "with onboarding pod" },
                  // { label: "Live since 2016", desc: "1,500+ FOs daily across 600K villages" },
                ].map((item, idx) => (
                  <li key={idx} className="flex gap-3.5 py-2.5 border-b border-dashed border-[#E3DAD0] last:border-b-0">
                    <span className="flex-shrink-0 w-6 h-5.5 bg-[#D8F0DF] text-[#176B33] rounded-full flex items-center justify-center text-[11px] font-bold mt-1">
                      ✓
                    </span>
                    <span className="text-base leading-relaxed text-[#3D362F]">
                      <strong>{item.label}</strong>
                      {item.desc && ` — ${item.desc}`}
                    </span>
                  </li>
                ))}
              </ul>
{/* 
              <button
                onClick={handleDemo}
                className="inline-flex items-center justify-center gap-2.5 px-7 py-4 bg-[#22A850] text-white rounded-xl text-base font-semibold transition-all duration-250 "
              >
                Book a platform demo
                <span className="transition-transform duration-250 group-hover:translate-x-1">→</span>
              </button> */}
            </div>

            {/* Marketing Pod Card */}
            <div className="bg-white border border-[#E3DAD0] rounded-3xl p-8 relative overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl flex flex-col">
              <div className="absolute top-0 left-0 right-0 h-1.5 bg-[#D85A30]"></div>
              
              <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#FBE8E0] rounded-full self-start mb-6">
                <span className="w-1.5 h-1.5 bg-[#D85A30] rounded-full"></span>
                <span className="text-[10.5px] font-medium text-[#B8431F] uppercase tracking-widest">
                  The Programme
                </span>
              </div>

              <h2 className="text-3xl font-semibold tracking-tight text-[#1A1612] mb-2">
                Marketing Pod
              </h2>
              <p className="text-lg text-[#7A6E62] mb-4">
                A 90-day managed marketing engagement.
              </p>

              <div className="py-2 border-t border-b border-[#E3DAD0] mb-8">
                <p className="text-[11px] uppercase tracking-widest text-[#7A6E62] mb-2.5">
                  Starting at
                </p>
                <div className="flex items-baseline gap-2 flex-wrap">
                  <span className="text-4xl font-medium text-[#1A1612]">₹</span>
                  <span className="text-4xl font-semibold leading-none tracking-tight text-[#1A1612]">
                    1,00,000
                  </span>
                  <span className="text-base font-medium text-[#7A6E62] ml-1">
                    / pod / 90 days
                  </span>
                </div>
              </div>

              {/* <div className="mb-4">
                <p className="text-base leading-relaxed text-[#3D362F]">
                  <strong className="text-[11px] font-semibold uppercase tracking-widest text-[#1A1612] block mb-2">
                    Ideal for
                  </strong>
                  Agri-input brands building demand around a Kharif, Rabi, or Zaid season — and the CMOs who need every rupee of spend to tie back to a farmer, an FO, and a sale.
                </p>
              </div> */}

              <p className="text-[15px] font-semibold uppercase tracking-widest text-[#1A1612] mb-4">
                One pod · Five FO markets · 90 days
              </p>

              <ul className="space-y-0 mb-9 flex-grow">
                {[
                  { label: "Dedicated Women Voice Agent", desc: "across 5 FO markets" },
                  { label: "FO Activity Validation", desc: "& Daily Reporting" },
                  { label: "Farmer & Retailer Engagement Calls", desc: "(recorded, audited)" },
                  { label: "AI Sales Agent & WhatsApp/SMS Automation", desc: "lead nurturing at scale" },
                  { label: "Social Media & Influencer Marketing ", desc: "targeted digital outreach" },
                  { label: "Pod manager", desc: "orchestrating six channels" },
                  // { label: "Add-ons available", desc: "AI Sales Agent, Influencer, Social, WhatsApp/SMS" },
                  // { label: "Kharif 2026 cohort intake", desc: "12 brand cap" },
                ].map((item, idx) => (
                  <li key={idx} className="flex gap-3.5 py-2.5 border-b border-dashed border-[#E3DAD0] last:border-b-0">
                    <span className="flex-shrink-0 w-6 h-5.5 bg-[#FBE8E0] text-[#B8431F] rounded-full flex items-center justify-center text-[11px] font-bold mt-1">
                      ✓
                    </span>
                    <span className="text-base leading-relaxed text-[#3D362F]">
                      <strong>{item.label}</strong>
                      {item.desc && ` — ${item.desc}`}
                    </span>
                  </li>
                ))}
              </ul>

              {/* <button
                onClick={handleDemo}
                className="inline-flex items-center justify-center gap-2.5 px-7 py-4 bg-[#D85A30] text-white rounded-xl text-base font-semibold transition-all duration-250"
              >
                Apply for Kharif 2026
                <span className="transition-transform duration-250 group-hover:translate-x-1">→</span>
              </button> */}
            </div>
          </div>

          {/* Bundle Stripe */}
          {/* <div className="max-w-4xl mx-auto rounded-2xl p-6 flex items-center justify-between gap-6 flex-wrap relative overflow-hidden border">
            <div className="absolute top-[-50%] right-[-10%] w-[60%] h-[200%] bg-gradient-radial from-[rgba(216,90,48,0.18)] to-transparent pointer-events-none"></div>
            
            <div className="relative z-10 flex-1 min-w-[240px]">
              <h3 className="font-serif text-2xl font-semibold mb-1.5 tracking-tight">
                Run them <em className="italic text-primary font-medium">together.</em>
              </h3>
              <p className="text-sm leading-relaxed">
                Most brands install the platform first, then activate a pod around their next season. Bundle pricing available — typically saves 10–15% vs standalone.
              </p>
            </div>
            
            <button
              onClick={() => router.push("/contact-us")}
              className="relative z-10 px-6 py-3 bg-primary text-white rounded-lg font-semibold text-sm inline-flex items-center gap-2 transition-transform duration-250 hover:translate-x-1"
            >
              See bundle pricing
              <span>→</span>
            </button>
          </div> */}

          {/* Disclaimer */}
          <div className="max-w-4xl mx-auto mt-2 p-6 bg-white rounded-r-xl">
            <p className="italic text-base leading-relaxed text-[#3D362F]">
              * All prices exclusive of GST. Final pricing depends on field force size, geography, programme scope, and add-on selection. Talk to us for a firm quote within one working day.
            </p>
          </div>
        </div>
      </section>

      {/* Help Section */}
      <section className="py-6 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="bg-white border border-[#E3DAD0] rounded-3xl p-8 text-center relative overflow-hidden">
            <div className="absolute top-[-100px] left-1/2 transform -translate-x-1/2 w-[600px] h-[300px] bg-gradient-radial from-[#FBE8E0] to-transparent opacity-65 pointer-events-none"></div>
            
            <div className="relative z-10">
              <span className="text-[11.5px] font-medium uppercase tracking-[0.18em] text-primary mb-3 inline-block">
                Talk to us
              </span>
              
              <h2 className="text-4xl font-medium leading-tight tracking-tight mb-3">
                Need help <em className="italic text-primary font-normal">choosing?</em>
              </h2>
              
              <p className="text-lg leading-relaxed text-[#7A6E62] max-w-2xl mx-auto mb-6">
                Our GTM team has been running agri-input seasons for ten years. Tell us what your season needs, and we'll bundle services, scope a pilot, or recommend exactly what you should — and shouldn't — buy.
              </p>

              <div className="flex justify-center gap-8 flex-wrap mb-6 py-4 border-t border-b border-[#E3DAD0]">
                <a href="https://www.farminsta.com" className="inline-flex items-center gap-2.5 text-sm text-[#3D362F] font-medium">
                  <Globe className="w-5 h-5 text-primary" />
                  www.farminsta.com
                </a>
                <a href="mailto:sales@farminsta.com" className="inline-flex items-center gap-2.5 text-sm text-[#3D362F] font-medium">
                  <Mail className="w-5 h-5 text-primary" />
                  sales@farminsta.com
                </a>
                <a href="tel:+918072488052" className="inline-flex items-center gap-2.5 text-sm text-[#3D362F] font-medium">
                  <Phone className="w-5 h-5 text-primary" />
                  +91 80724 88052
                </a>
              </div>

              <div className="flex justify-center gap-4 flex-wrap">
                <Button
                  onClick={handleDemo}
                  className="bg-primary hover:bg-secondary text-white px-7 py-4 text-base font-bold rounded-sm transition duration-300 ease-in-out transform hover:scale-105"
                >
                  Get Started Today
                </Button>
                {/* <button
                  onClick={handleDemo}
                  className="px-7 py-4 bg-transparent border-2 rounded-xl text-base font-semibold transition-all duration-250"
                >
                  Book a 30-min consultation
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <DemoModal/>
    </div>
  );
};

const Page = () => {
  return (
    <>
      <FarminstaIntroLayout currentPage="price">
        <FarminstaPricing />
      </FarminstaIntroLayout>
    </>
  );
};

export default Page;
